import { useContext, useEffect } from 'react';

import { PortfolioManagementContext } from '../../../../../providers/portfolio-management';

import { PortfolioRiskSettingsToggleItem } from './portfolio-risk-settings-toggle-item';
import './styles.scss';

export const PortfolioRiskSettingsToggles = () => {
  const { setRiskSettingsSelected, riskSettingsSelected, mapDataAccounts, aggregatedData } =
    useContext(PortfolioManagementContext);

  const handleToggle = <K extends keyof typeof riskSettingsSelected>(key: K, value: boolean) => {
    setRiskSettingsSelected((prevState) => {
      const newState = {
        ...prevState,
        [key]: value,
      };

      if (key === 'isSpotOverride' && value) {
        newState.isFreezeSpotOverride = false;
      }

      if (key === 'isFreezeSpotOverride' && value) {
        newState.isSpotOverride = false;
      }

      return newState;
    });
  };

  const isToggleDisabled =
    !Object.values(mapDataAccounts).some((item) => item.length > 0) &&
    !Object.values(aggregatedData).some((item) => item.length > 0);

  useEffect(() => {
    if (isToggleDisabled) {
      handleToggle('isFreezeSpotOverride', false);
    }
  }, [isToggleDisabled]);

  return (
    <div className="portfolio-risk-settings-toggles-container">
      <PortfolioRiskSettingsToggleItem
        label="00:00 UTC Spot"
        description="Use this Spot instead of Live Spot"
        isEnabled={riskSettingsSelected.isSpotOverride}
        onToggle={(value) => handleToggle('isSpotOverride', value)}
      />

      <PortfolioRiskSettingsToggleItem
        label="Freeze Spot"
        description="Fix a Spot for risk scenarios"
        isEnabled={riskSettingsSelected.isFreezeSpotOverride}
        isDisabled={isToggleDisabled}
        onToggle={(value) => {
          if (isToggleDisabled) return;

          handleToggle('isFreezeSpotOverride', value);
        }}
      />

      <PortfolioRiskSettingsToggleItem
        label="Prioritize Trader Vols"
        description="Marked vols take precedence over Immersive vols"
        isEnabled={riskSettingsSelected.isOtcTraderVols}
        onToggle={(value) => handleToggle('isOtcTraderVols', value)}
      />
    </div>
  );
};
